
export enum PaymentStatus {
  Prepared = 'Prepared',
  Started = 'Started',
  InProgress = 'InProgress',
  Canceled = 'Canceled',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
  Expired = 'Expired'
}
